var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{ref:`dropdown_${_vm._uid}`,staticClass:"mr-2 mt-2 py-2 bg-white rounded-lg shadow-xl",staticStyle:{"position":"fixed","z-index":"10","width":"200px"},attrs:{"id":"r-dropdown"}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }